export const claimSubcategories = {
  physical_damage: [
    { value: 'scratch_paint', label: 'Scratch / Paint' },
    { value: 'dent_ding', label: 'Dent / Ding' },
    { value: 'glass_windshield', label: 'Glass / Windshield' },
    { value: 'structural_collision', label: 'Structural / Collision' },
    { value: 'interior_damage', label: 'Interior Damage' },
    { value: 'wheels_tires_rims', label: 'Wheels / Tires / Rims' },
    { value: 'mirrors_lights', label: 'Mirrors / Lights' },
    { value: 'odometer_discrepancy', label: 'Odometer Discrepancy' },
    { value: 'missing_parts', label: 'Missing Parts' },
    { value: 'battery_issues', label: 'Battery Issues' },
  ],
  operational_failure: [
    { value: 'delay_late_delivery', label: 'Delay / Late Delivery' },
    { value: 'vehicle_not_picked_up', label: 'Vehicle Not Picked Up' },
    { value: 'communication_failure', label: 'Communication Failure' },
  ],
  financial_billing: [
    { value: 'overcharge_dispute', label: 'Overcharge Dispute' },
    { value: 'refund_request', label: 'Refund Request' },
    { value: 'insurance_deductible_dispute', label: 'Insurance / Deductible Dispute' },
  ],
};

export const claimSeverityOptions = [
  { value: 'low',      label: 'Low',      badge: 'grayBadge',   colorClass: 'gray-text'   },
  { value: 'medium',   label: 'Medium',   badge: 'blueBadge',   colorClass: 'blue-text'   },
  { value: 'high',     label: 'High',     badge: 'orangeBadge', colorClass: 'orange-text' },
  { value: 'critical', label: 'Critical', badge: 'redBadge',    colorClass: 'red-text'    },
];

export const claimFaultPartyOptions = [
  { value: 'carrier',  label: 'Carrier',  badge: 'orangeBadge', colorClass: 'orange-text' },
  { value: 'customer', label: 'Customer', badge: 'blueBadge',   colorClass: 'blue-text'   },
];

export const claimPhotosOptions = [
  { value: 'yes',     label: 'Yes',     badge: 'greenBadge',  colorClass: 'green-text'  },
  { value: 'partial', label: 'Partial', badge: 'yellowBadge', colorClass: 'yellow-text' },
  { value: 'no',      label: 'No',      badge: 'redBadge',    colorClass: 'red-text'    },
];

export const claimBooleanOptions = [
  { value: true,  label: 'Yes', badge: 'greenBadge', colorClass: 'green-text' },
  { value: false, label: 'No',  badge: 'redBadge',   colorClass: 'red-text'   },
];

export const claimStatusOptions = [
  { value: 'open',            label: 'Open',            badge: 'redBadge',    text: 'red-text'    },
  { value: 'in_progress',     label: 'In Progress',     badge: 'orangeBadge', text: 'orange-text' },
  { value: 'pending_carrier', label: 'Pending Carrier', badge: 'yellowBadge', text: 'yellow-text' },
  { value: 'closed_paid',     label: 'Closed — Paid',   badge: 'greenBadge',  text: 'green-text'  },
  { value: 'closed_denied',   label: 'Closed — Denied', badge: 'grayBadge',   text: 'gray-text'   },
  { value: 'escalated',       label: 'Escalated',       badge: 'purpleBadge', text: 'purple-text' },
];

export const claimCategoryLabels = {
  physical_damage: 'Physical Damage',
  operational_failure: 'Operational Failure',
  financial_billing: 'Financial / Billing',
};
